import { render } from "./AssetItem.vue?vue&type=template&id=199fca06&scoped=true"
import script from "./AssetItem.vue?vue&type=script&lang=js"
export * from "./AssetItem.vue?vue&type=script&lang=js"

import "./AssetItem.vue?vue&type=style&index=0&id=199fca06&scoped=true&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-199fca06"]])

export default __exports__